/* «История». Оболочка — экран React: колонка #history и пустой лист работы.
   Тело списка отдаёт prepare() один раз. Дальше раздел сам меняет узлы, и React этот кадр не перерисовывает.
   Лист внутри страницы: его рамка — колонка .view, как у прототипа. */
import { useLayoutEffect, useState } from 'react';
import { uiText, useAccountLocale } from '../../i18n';
import { historyApi } from './module';

export function History() {
  const api = historyApi();
  // подпись листа — на языке профиля (тело раздел перерисовывает сам по steos:locale)
  useAccountLocale();
  const [m] = useState(() => api.prepare());
  useLayoutEffect(() => {
    api.attach();
  }, [api]);
  return (
    <div className={'pg stp' + (m.zero ? ' hs-zero' : '')} id="history">
      <div className="stp-in">
        <div className="hs-body" id="hsBody" dangerouslySetInnerHTML={{ __html: m.body }} />
      </div>
      <div className="bscrim" id="hsSheetScrim" data-bsheet-x="" />
      <aside className="side bsheet" id="hsSheet" role="dialog" aria-label={uiText('Работа из истории')} aria-hidden="true" />
    </div>
  );
}
